<div class="wrapper">
  <header class="dialog-header">
    <h1 class="header-heading" *ngIf="data.transactionType === TransactionType.SUBSCRIPTION">{{ 'pages.user-receipts.detail.header.SUBSCRIPTION' | translate }}</h1>
    <h1 class="header-heading" *ngIf="data.transactionType !== TransactionType.SUBSCRIPTION">{{ 'pages.user-receipts.detail.header.PARKING' | translate }}</h1>
    <button class="close-button" (click)="closeDialog()"></button>
  </header>

  <div class="dialog-content">
    <!-- Articles -->
    <h2 class="main-label left-indentation">{{ 'pages.user-receipts.detail.items' | translate }}</h2>
    <div class="section-container">
      <ng-container *ngIf="data.transactionType === TransactionType.SUBSCRIPTION">
        <div class="detail-container w-100">
          <!-- Items details -->
          <div class="item-container" *ngFor="let item of data.items">
            <h3 class="item-header">{{ item.name || item.description }}</h3>
            <h4 class="item-subheader">{{ item.code }}</h4>
          </div>
          <div class="info-container">
            <div class="info-row info-row--organisation" *ngIf="data?.organisation">
              <span class="label">{{ 'pages.user-receipts.detail.city' | translate }}</span>
              <span class="data">{{ data.organisation }}</span>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="data.transactionType !== TransactionType.SUBSCRIPTION">
        <div class="detail-container w-100"  *ngFor="let item of data.items">
          <!-- Items details -->
          <div class="item-container">
            <h3 class="item-header" *ngIf="!isUDES && data.transactionType === TransactionType.PARKING">{{ 'pages.user-receipts.detail.item.PARKING' | translate }}</h3>
            <h3 class="item-header" *ngIf="isUDES && data.transactionType === TransactionType.PARKING">{{ 'pages.user-receipts.detail.item.PARKING_UDES' | translate }}</h3>
            <h3 class="item-header" *ngIf="data.transactionType === TransactionType.PARKING_PLAN">{{ 'pages.user-receipts.detail.item.PARKING_PLAN' | translate }}</h3>
            <h3 class="item-header" *ngIf="data.transactionType === TransactionType.PARKING_PERMIT">{{ 'pages.user-receipts.detail.item.PARKING_PERMIT' | translate }}</h3>
          </div>
          <div class="info-container">
            <div class="info-row" *ngIf="data?.organisation">
              <span class="label">{{ 'pages.user-receipts.detail.city' | translate }}</span>
              <span class="data">{{ data.organisation }}</span>
            </div>

            <div class="info-row" *ngIf="item?.zone">
              <span class="label">{{ 'pages.user-receipts.detail.parking-zone' | translate }}</span>
              <span class="data">{{ item?.zone }}</span>
            </div>
  
            <div class="info-row" *ngIf="item?.licensePlate">
              <span class="label">{{ 'pages.user-receipts.detail.license-plate' | translate }}</span>
              <span class="data">{{ item?.licensePlate }}</span>
            </div>
  
            <div class="info-row" *ngIf="item?.start && !isBadDate(item.start)">
              <span class="label">{{ 'pages.user-receipts.detail.start' | translate }}</span>
              <span class="data">{{ item.start | localizeDate: shortTimeOptions }}</span>
            </div>
  
            <div class="info-row" *ngIf="item?.end && !isBadDate(item.end)">
              <span class="label">{{ 'pages.user-receipts.detail.end' | translate }}</span>
              <span class="data">{{ item.end | localizeDate:shortTimeOptions }}</span>
            </div>
          </div>
        </div>
      </ng-container>
    </div>


    <mat-divider class="w-100"></mat-divider>

    <!-- Transaction -->
    <div class="section-container">
      <h2 class="main-label">{{ 'pages.user-receipts.detail.transaction' | translate }}</h2>
      <div class="detail-container w-100">
        <div class="info-container">
          <div class="info-row">
            <span class="label">{{ 'pages.user-receipts.detail.paymentMethodType.label' | translate }}</span>
            <span *ngIf="data.paymentMethodType === PaymentMethodType.PREPAID" class="data">{{ 'pages.user-receipts.detail.paymentMethodType.PREPAID' | translate }}</span>
            <span *ngIf="data.paymentMethodType === PaymentMethodType.FREE" class="data">{{ 'pages.user-receipts.detail.paymentMethodType.FREE' | translate }}</span>
            <span *ngIf="data.paymentMethodType === PaymentMethodType.COUNTER" class="data">{{ 'pages.user-receipts.detail.paymentMethodType.COUNTER' | translate }}</span>
            <span *ngIf="data.paymentMethodType === PaymentMethodType.CREDIT_CARD && data.transactionType !== TransactionType.CREDIT" class="data">{{ 'pages.user-receipts.detail.paymentMethodType.CREDIT_CARD' | translate }}</span>
            <span *ngIf="data.paymentMethodType === PaymentMethodType.CREDIT_CARD && data.transactionType === TransactionType.CREDIT" class="data">{{ 'pages.user-receipts.detail.paymentMethodType.CREDIT' | translate }}</span>
          </div>
          <div class="info-row">
            <span class="label">{{ 'pages.user-receipts.detail.receipt-no' | translate }}</span>
            <span class="data">{{ data.receiptNumber }}</span>
          </div>

          <div class="info-row">
            <span class="label">{{ 'pages.user-receipts.detail.date-time' | translate }}</span>
            <span class="data">{{ data.created_at | localizeDate:fullDateTimeOptions }}</span>
          </div>

          <div *ngIf="data.transactionType === TransactionType.SUBSCRIPTION" class="info-container">
            <div class="info-row" *ngFor="let item of data.items">
              <span class="label">{{ 'pages.user-receipts.detail.item.subscription' | translate }} ({{ item.code }})</span>
              <span class="data">{{ item.amount | localizeCurrency }}</span>
            </div>
          </div>


          <div *ngIf="data.transactionType !== TransactionType.SUBSCRIPTION  ">
            <div class="info-row" *ngFor="let item of data.items">
              <span class="label" [innerHTML]="getItemNameOrDescription(item.name,item.description) | safeHtml"></span>
              <span class="data">{{ item.amount | localizeCurrency }}</span>
            </div>
          </div>
          

          <div class="info-row" *ngIf="data.serviceFees">
            <span class="label">{{ 'pages.user-receipts.detail.service-fee' | translate }}</span>
            <span class="data">{{ data.serviceFees | localizeCurrency }}</span>
          </div>

          <div class="info-row" *ngIf="data.subtotal">
            <span class="label">{{ 'pages.user-receipts.detail.subtotal' | translate }}</span>
            <span class="data">{{ data.subtotal | localizeCurrency }}</span>
          </div>

          <ng-container *ngIf="data.paymentMethodType !== PaymentMethodType.PREPAID">
            <div *ngFor="let tax of data?.taxes" class="info-row">
              <span class="label">{{ taxNumber(tax.name, tax.taxNumber)}}</span>
              <span class="data">{{ tax.amount | localizeCurrency }}</span>
            </div>
          </ng-container>


          <div class="info-row" *ngIf="data.paymentMethodType !== PaymentMethodType.PREPAID">
            <span class="label">{{ 'pages.user-receipts.detail.total-price' | translate }}</span>
            <span class="data">{{ data.total | localizeCurrency }}</span>
          </div>
        </div>
      </div>
    </div>


    <mat-divider class="w-100" *ngIf="data.paymentMethodType !== PaymentMethodType.PREPAID && data.paymentMethodType !== PaymentMethodType.FREE"></mat-divider>

    <!-- Payment method -->
    <div class="section-container" *ngIf="data.paymentMethodType !== PaymentMethodType.PREPAID && data.paymentMethodType !== PaymentMethodType.FREE">
      <h2 class="main-label">
        <ng-container *ngIf="data.transactionType === TransactionType.CREDIT">
          {{ 'pages.user-receipts.detail.refund-method' | translate }}
        </ng-container>
        <ng-container *ngIf="data.transactionType !== TransactionType.CREDIT">
          {{ 'pages.user-receipts.detail.payment-method' | translate }}
        </ng-container>
      </h2>
      <div class="detail-container w-100">
        <div class="info-container">

          <!-- COUNTER payment details -->
          <ng-container *ngIf="data.paymentMethodType === PaymentMethodType.COUNTER">
            <div class="info-row">
              <span class="label">{{ 'pages.user-receipts.detail.paymentMethodType.COUNTER' | translate }}</span>
            </div>
            <div class="info-row" *ngIf="data.paymentDetails?.authorizationNumber">
              <span class="label">{{ 'pages.user-receipts.detail.paymentDetails.reference-number' | translate }}</span>
              <span class="data">{{ data.paymentDetails.authorizationNumber }}</span>
            </div>
            <div class="info-row">
              <span class="label">{{ 'pages.user-receipts.detail.price' | translate }}</span>
              <span class="data">{{ (data.total | localizeCurrency) || "-" }}</span>
            </div>
          </ng-container>

          <!-- Credit card payment details -->
          <ng-container *ngIf="data.paymentMethodType !== PaymentMethodType.COUNTER">
            <div class="info-row">
              <span class="label">{{ 'pages.user-receipts.detail.paymentDetails.card-number' | translate }}</span>
              <span class="data">{{ data.paymentDetails?.cardNumber || "-" }}</span>
            </div>

            <div class="info-row">
              <span class="label">{{ 'pages.user-receipts.detail.paymentDetails.card-type' | translate }}</span>
              <span class="data">{{ (data.paymentDetails?.cardType?.replace('_', ' ') | uppercase) || "-" }}</span>
            </div>

            <div class="info-row">
              <span class="label">{{ 'pages.user-receipts.detail.paymentDetails.transaction-number' | translate }}</span>
              <span class="data">{{ data.paymentDetails?.transactionNumber || "-" }}</span>
            </div>

            <div class="info-row">
              <span class="label">{{ 'pages.user-receipts.detail.paymentDetails.authorization-number' | translate }}</span>
              <span class="data">{{ data.paymentDetails?.authorizationNumber || "-" }}</span>
            </div>

            <div class="info-row">
              <span class="label">{{ 'pages.user-receipts.detail.price' | translate }}</span>
              <span class="data">{{ (data.total | localizeCurrency) || "-" }}</span>
            </div>
          </ng-container>

        </div>
      </div>
    </div>

    <div class="section-container" *ngIf="!data.transactionSuccess">
      <div class="failed-transaction">{{ 'pages.user-receipts.transaction-failed' | translate }}</div>
    </div>

    <div class="section-container download">
      <button class="bciti-button bciti-button--blue" (click)="generatePDF()">
        {{ 'pages.user-receipts.detail.download' | translate }}
      </button>
    </div>
  </div>
  
</div>